import { botChatPayload } from "../../interfaces/bot"
import BASEURLZAI from "../api/zai"
import ZAIFORMDATA from "../api/zaiFormData"

export function novoTicketSite(payload: botChatPayload) {
    return BASEURLZAI.post('/bot/chat', payload)
}

export function enviarMensagem(idTicket: string, payload: FormData) {
    return ZAIFORMDATA.post(`/bot/chat/msg/${idTicket}`, payload)
}